module.exports = __webpack_public_path__ + "img/98bbdc_TC.fec67f05.jpg";